module.exports = __webpack_public_path__ + "img/icon_img33.7cff6a75.png";